import { IAction } from "../../../base/common/actions";
import { Emitter, Event } from "../../../base/common/events";
import { Disposable } from "../../../base/common/lifecycle";
import { localize, localize2 } from "../../../base/common/nls";
import { getFlatContextMenuActions } from "../../../editor/services/titlebar/menuEntryActionViewItem";
import { getIconId } from "../../action/common/action";
import { IMenuService, isIMenuItem, MenuId, MenuItemAction, MenuRegistry, SubmenuItemAction } from "../../actions/common/actions";
import { IContextKeyService } from "../../contextkey/common/contextkey";
import { ContextMenuContext, IContextMenuItem, IContextMenuService, IContextMenuSubItem, WillShowContextMenuArguments } from "./context";



export class ContextMenuService extends Disposable implements IContextMenuService {

    // private static _willShowContextMenu = new Emitter<WillShowContextMenuArguments>();
    // static onWillShowContextMenu: Event<WillShowContextMenuArguments> = this._willShowContextMenu.event;

    readonly _serviceBrand: undefined;

    constructor(
        @IMenuService private readonly menuService: IMenuService,
        @IContextKeyService private readonly contextKeyService: IContextKeyService,
    ) {
        super();
    }


    private readonly _onWillShowContextMenu = this._register(new Emitter<WillShowContextMenuArguments>());
    public readonly onWillShowContextMenu = this._onWillShowContextMenu.event;

    getContextMenuItems(context: ContextMenuContext): Array<IContextMenuItem | IContextMenuSubItem> {

        // ContextMenuService._willShowContextMenu.fire({ context });
        this._onWillShowContextMenu.fire({ context });

        const groups = this.menuService.getMenuActions(context.menuId, this.contextKeyService);
        const actions = getFlatContextMenuActions(groups);
        const result = new Array<IContextMenuItem | IContextMenuSubItem>();
        this.populateMenuItems(actions, result, context);
        // result.push({
        //     label: "test",
        //     icon: undefined,
        //     action: () => {},
        // }, {
        //     label: "submenu",
        //     icon: "file",
        //     subItems: [{
        //         label: "subtest",
        //         icon: undefined,
        //         action: () => {}
        //     }]
        // })
        return result;
    }

    private populateMenuItems(menuItems: readonly IAction[], array: Array<IContextMenuItem | IContextMenuSubItem>, context: ContextMenuContext): void {
        for (const menuItem of menuItems) {
            if (menuItem instanceof MenuItemAction || menuItem instanceof SubmenuItemAction) {
                if (menuItem instanceof MenuItemAction) {
                    array.push({
                        label: menuItem.label,
                        icon: menuItem.item?.icon ? getIconId(menuItem.item.icon) : undefined,
                        tooltip: menuItem.tooltip,
                        enabled: menuItem.enabled,
                        action: () => {
                            menuItem.run(context);
                        }
                    });
                } else if (menuItem instanceof SubmenuItemAction) {
                    const subItem: IContextMenuSubItem = {
                        label: menuItem.label,
                        icon: menuItem.item?.icon ? getIconId(menuItem.item.icon) : undefined,
                        enabled: menuItem.enabled,
                        subItems: [],
                    };
                    this.populateMenuItems(menuItem.actions, subItem.subItems, context);
                    array.push(subItem);
                }
            }
        }
    }
}
